import AmountCell from './AmountCell';

export default AmountCell;
